export default __webpack_public_path__ + "static/contact-alt-abb4af9250ce6b90934dd351b4d7a7da.jpg";